import { useMutation } from "react-query";

import { UserDto } from "doxecure-commons/lib/doxecureClientTypes";

import { createNewUser } from "@services/users.service";

const useCreateUser = () => useMutation((values: UserDto) => createNewUser(values));

export default useCreateUser;
